var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.03 8.53l-4.5 4.5a.751.751 0 11-1.062-1.062l3.22-3.218H2.5a.75.75 0 010-1.5h9.188L8.469 4.03a.751.751 0 011.063-1.063l4.5 4.5a.75.75 0 01-.001 1.063z",
    fill: "#4945FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default "/_next/static/images/cfbd1d935be60b091f81a462f2f3b1a7.svg";
export { ForwardRef as ReactComponent };